export const isMobileSize = () => {
  return window.innerWidth <= 768;
};